import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import TruckGroup from './truck-group';
import TruckGroupUpdate from './truck-group-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TruckGroupUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TruckGroupUpdate} />
      <ErrorBoundaryRoute path={match.url} component={TruckGroup} />
    </Switch>
  </>
);

export default Routes;
